type SessionStorage = {
    createdAt: number;
    updatedAt: number;
    data: {
        config: string;
        input: string;
    };
};

const DB_KEY = 'TB_SESSION';

export class SessionsDataManager {
    getSessionData() {
        try {
            const response = window.sessionStorage.getItem(DB_KEY) as string;

            return JSON.parse(response) as SessionStorage;
        } catch (e) {
            return null;
        }
    }

    setSessionData(data: SessionStorage) {
        window.sessionStorage.setItem(DB_KEY, JSON.stringify(data));
    }

    saveSessionConfigWithInput(config: string, input: string) {
        const session = this.getSessionData();

        const currentTs = Date.now();

        if (!session) {
            this.setSessionData({
                createdAt: currentTs,
                updatedAt: currentTs,
                data: { config, input }
            });
        } else {
            session.updatedAt = currentTs;
            session.data = { config, input };

            this.setSessionData(session);
        }
    }
}
